import Vue from 'vue'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const dollar2peso = base =>
  Vue.$http.get('latest', { baseURL: 'https://api.exchangeratesapi.io/',
    params: { base },
    transformRequest: [(data, headers) => {
      delete headers.common.Authorization
      return data
    }],
  })
    .then(response => response.data)
    .catch((err) => { throw err })


export default dollar2peso


// WEBPACK FOOTER //
// ./src/services/extranet/dollar2peso.js